"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fileDownloadEndpoint = exports.fileUploadEndpoint = void 0;
var t = __importStar(require("typed-validators"));
var utils_1 = require("~shared/utils");
var fileUploadFormValidator = t.object({
    optional: {
        name: t.string()
    }
});
var fileUploadReturnValidator = t.oneOf(t.object({
    required: {
        message: t.string(),
        success: t.boolean(false)
    },
    optional: {
        id: t.string()
    }
}), t.object({
    message: t.string(),
    success: t.boolean(true),
    id: t.string()
}));
exports.fileUploadEndpoint = utils_1.asSingleFileFormEndpoint({
    method: 'post',
    apiPath: '/file/upload',
    fileFormName: 'file',
    requestForm: fileUploadFormValidator,
    responseBody: fileUploadReturnValidator
});
var fileDownloadValidator = t.object({
    id: t.string()
});
exports.fileDownloadEndpoint = utils_1.asDownloadEndpoint({
    method: 'get',
    apiPath: '/file/download/:id',
    requestParams: fileDownloadValidator
});
//# sourceMappingURL=file.js.map